import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { portfolioData as d } from '../mock';
import Masthead from './portfolio/Masthead';
import Navigation from './portfolio/Navigation';
import Hero from './portfolio/Hero';
import CategoryGrid from './portfolio/CategoryGrid';
import AboutSection from './portfolio/AboutSection';
import Footer from './portfolio/Footer';
import { scrollToSection } from '../lib/navHelpers';

const Portfolio = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.state?.scrollTo) {
      // Give layout a beat to render then scroll
      setTimeout(() => scrollToSection(location.state.scrollTo), 60);
    }
  }, [location.state]);

  return (
    <div className="min-h-screen paper-texture text-[#1a1a1a]">
      <div className="max-w-[1200px] mx-auto px-6 py-6">
        <Masthead data={d} />
        <Navigation items={d.navigation} />
        <Hero hero={d.hero} editorNote={d.editorNote} />
        <CategoryGrid categories={d.categories} tools={d.tools} />
        <AboutSection about={d.about} whatIDo={d.whatIDo} />
        <Footer footer={d.footer} />
      </div>
    </div>
  );
};

export default Portfolio;
